<template>
  <div>

    <DataTable 
      :value="data"
      :paginator="true"
      paginatorPosition="top"
      dataKey="id"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="50"
      :rowHover="true"
      :selection.sync="selectedRows"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Filters"
      :scrollable="true"
      frozenWidth="0px"
      scrollHeight="400px"
      :resizableColumns="true" 
      columnResizeMode="expand"
    >
      <Column 
        header="Actions"
        :frozen="true"
      >
      </Column>
      <Column 
        field="favouriteOrder" 
        header="Filter order"
        headerStyle="width: 2rem"
      >
        <template #body="slotProps">
          {{ slotProps.data.favouriteOrder }}
        </template>
      </Column>
      <Column 
        field="favouriteName" 
        header="Name"
        headerStyle="width: 10rem"
      >
        <template #body="slotProps">
          {{ slotProps.data.favouriteName }}
        </template>
      </Column>
      <Column 
        field="whereClause" 
        header="Where clause"
        headerStyle="width: 20rem"
      >
        <template #body="slotProps">
          {{ slotProps.data.whereClause }}
        </template>
      </Column>
      <Column 
        field="orderByClause" 
        header="Order by"
        headerStyle="width: 10rem"
      >
        <template #body="slotProps">
          {{ slotProps.data.orderByClause }}
        </template>
      </Column>
      <Column 
        field="favourite" 
        header="Favourite?"
        headerStyle="width: 5em"
      >
        <template #body="slotProps">
          <ToggleButton 
            @click="toggleFavourite(slotProps.data)"
            v-model="slotProps.data.favourite" 
            onLabel="Yes" 
            offLabel="No" 
            onIcon="pi pi-check" 
            offIcon="pi pi-times" 
            style="width: 100%"
            class="p-button-sm"
          />
        </template>
      </Column>
    </DataTable>

  </div>
</template>

<script>
import FiltersService from "../../../service/FiltersSerice";

export default {
  created() {
    this.data = this.savedFilters
  },
  props: {
    savedFilters: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    filters: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    filtersService: new FiltersService(),
    selectedRows: [],
    data: []
  }),
  watch: {
    savedFilters(val) {
      this.data = val
    }
  },
  methods: {
    toggleFavourite(filter) {
      
      
      // setTimeout(() => {
        
        this.filtersService
          .setSavedFilterFav(filter.id, filter.favourite ? 0 : 1)
          .then(data => {
            this.$emit('updateFilter', {
              ...filter,
             favourite: !filter.favourite
            })
          })
          .catch(error => {
            
              let filterIndex = this.data.findIndex(f => f.id === filter.id)
              if (filterIndex >= 0) {
                this.data[filterIndex].favourite = filter.favourite
              }

            this.$toast.add({
              severity: "error",
              summary: "Can't change favorite...",
              detail: "Error while changing favorite status of this filter.",
              life: 5000,
            })
          })
      // }, 1)
    }
  }
}
</script>

<style>

</style>